import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'subscriptionsFilter', namespaced: true })
export default class SubscriptionsFilter extends FilterModule {
    constructor(module: SubscriptionsFilter) {
        super(module);
    }
}
